import {
  Box,
  Button,
  Text,
  ButtonGroup,
  Container,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../../../components/Logo";
import { Sidebar } from "./Sidebar";
import { ToggleButton } from "./ToggleButton";
import { clearToken } from "../../../lib/store";
import { useUser } from "@clerk/clerk-react";
import { SignOutButton } from "@clerk/clerk-react";
import styled from "@emotion/styled";
interface NavbarProps {
  user?: User;
}

// button:nth-child(2) {
const StyledButtonGroup = styled(ButtonGroup)`
  button {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    position: relative;
    white-space: nowrap;
    vertical-align: middle;
    outline: 2px solid transparent;
    outline-offset: 2px;
    line-height: 1.2;
    border-radius: var(--chakra-radii-md);
    font-weight: var(--chakra-fontWeights-semibold);
    transition-property: var(--chakra-transition-property-common);
    transition-duration: var(--chakra-transition-duration-normal);
    height: var(--chakra-sizes-10);
    min-width: var(--chakra-sizes-10);
    font-size: var(--chakra-fontSizes-md);
    -webkit-padding-start: var(--chakra-space-4);
    padding-inline-start: var(--chakra-space-4);
    -webkit-padding-end: var(--chakra-space-4);
    padding-inline-end: var(--chakra-space-4);
    color: var(--chakra-colors-brand-black);
    background: var(--chakra-colors-transparent);
    &:hover {
      var(--chakra-colors-transparent);
    }
  }
`;

export const Navbar = ({ user }: NavbarProps) => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const { isOpen, onToggle, onClose } = useDisclosure();
  const navigate = useNavigate();

  const handleSignOut = () => {
    clearToken();
  };

  const fullName = `${user?.firstName} ${user?.lastName}`;
  const clerkUser = useUser();

  const href = window.location.href;
  const isOnNavigableSubpage = href.endsWith('users') || href.endsWith('organization') || href.endsWith('organizations');

  return (
    <Box as="nav" bg="bg-accent" color="on-accent">
      <Container maxW="6xl" py={{ base: "3", lg: "4" }}>
        {isDesktop && (
          <Flex justifyContent="flex-end" paddingBottom="8px">
            <Text fontSize="sm" color="gray.500">
              {clerkUser.user?.fullName}
            </Text>
          </Flex>
        )}
        <Flex justify="space-between">
          <Flex direction="row" gap="6">
            <Logo maxW={150} onClick={() => navigate("/")} cursor="pointer" />
            {isDesktop ? (
              <Flex direction="row" gap="3">
                {(user && user.isRxAdmin) ? <Button variant={window.location.href.endsWith('users') ? 'solid' : 'outline'} onClick={() => navigate("/users")}>All Providers</Button> : null}
                {(user && user.isRxAdmin) ? <Button variant={window.location.href.endsWith('organizations') ? 'solid' : 'outline'} onClick={() => navigate("/organizations")}>Organizations</Button> : null}
                {(user && user.isOrgAdmin) ? <Button variant={window.location.href.endsWith('organization') ? 'solid' : 'outline'} onClick={() => navigate("/organization")}>My Organization</Button> : null}
                <Button variant={isOnNavigableSubpage ? 'outline' : 'solid'} onClick={() => navigate("/")}>My Clients</Button>
              </Flex>
            ) : <></>}
          </Flex>
          {isDesktop ? (
            <Flex direction="row" gap="3">
              <SignOutButton signOutCallback={handleSignOut}>
                <Button variant="outline">
                  Sign Out
                </Button>
              </SignOutButton>
            </Flex>
          ) : (
            <>
              <ToggleButton
                isOpen={isOpen}
                aria-label="Open Menu"
                onClick={onToggle}
              />
              <Drawer
                isOpen={isOpen}
                placement="left"
                onClose={onClose}
                isFullHeight
                preserveScrollBarGap
                // Only disabled for showcase
                trapFocus={false}
              >
                <DrawerOverlay />
                <DrawerContent>
                  <Sidebar name={fullName} user={user} />
                </DrawerContent>
              </Drawer>
            </>
          )}
        </Flex>
      </Container>
    </Box >
  );
};
